import {
  // GET PROMOTION DETAIL
  GET_PROMOTION_DETAIL,
  GET_PROMOTION_DETAIL_SUCCESS,
  GET_PROMOTION_DETAIL_FAILED,

  // GET PROMOTION LIST
  GET_PROMOTION_LIST,
  GET_PROMOTION_LIST_SUCCESS,
  GET_PROMOTION_LIST_FAILED,

  // CREATE BASIC PROMOTION
  CREATE_PROMOTION,
  CREATE_PROMOTION_SUCCESS,
  CREATE_PROMOTION_FAILED,

  // EDIT BASIC PROMOTION
  EDIT_PROMOTION,
  EDIT_PROMOTION_SUCCESS,
  EDIT_PROMOTION_FAILED,

  // DELETE BASIC PROMOTION
  DELETE_PROMOTION,
  DELETE_PROMOTION_SUCCESS,
  DELETE_PROMOTION_FAILED,

  // CLEAR PROMOTION DETAIL
  CLEAR_PROMOTION_DETAIL,

  // CREATE PLACE PROMOTION
  CREATE_PLACE_PROMOTION,
  CREATE_PLACE_PROMOTION_SUCCESS,
  CREATE_PLACE_PROMOTION_FAILED,
  GET_PLACE_PROMOTION_DETAIL,
  GET_PLACE_PROMOTION_DETAIL_SUCCESS,
  GET_PLACE_PROMOTION_DETAIL_FAILED,
  CLEAR_PLACE_PROMOTION_DETAIL,
  DELETE_PLACE_PROMOTION,
  DELETE_PLACE_PROMOTION_SUCCESS,
  DELETE_PLACE_PROMOTION_FAILED,
  GET_PLACE_PROMOTION_LIST,
  GET_PLACE_PROMOTION_LIST_SUCCESS,
  GET_PLACE_PROMOTION_LIST_FAILED,
  DELETE_PROMOTION_DISCOUNT,
  DELETE_PROMOTION_DISCOUNT_SUCCESS,
  DELETE_PROMOTION_DISCOUNT_FAILED,
  GET_USABLE_MARKETING_PROMOTION_LIST,
  GET_USABLE_MARKETING_PROMOTION_LIST_SUCCESS,
  GET_USABLE_MARKETING_PROMOTION_LIST_FAILED,
  GET_USABLE_MARKETING_PROMOTION_DETAIL,
  GET_USABLE_MARKETING_PROMOTION_DETAIL_SUCCESS,
  GET_USABLE_MARKETING_PROMOTION_DETAIL_FAILED,
  CLEAR_USABLE_MARKETING_PROMOTION_DETAIL,
} from './actionTypes';

const initialState = {
  isLoadingGetPromotionDetail: false,
  isLoadingGetPromotionList: false,
  isLoadingCreatePromotion: false,
  isLoadingDeletePromotion: false,
  isLoadingCreatePlacePromotion: false,
  isLoadingGetPlacePromotionDetail: false,
  isLoadingGetPlacePromotionList: false,
  isLoadingDeletePromotionDiscount: false,
  isLoadingGetUsableMarketingPromotionList: false,
  isLoadingGetUsableMarketingPromotionDetail: false,

  promotionDetail: {},
  placePromotionDetail: {},
  promotionList: [],
  placePromotionList: [],
  usableMarketingPromotionList: [],
  usableMarketingPromotionDetail: {},
  promotionTotal: 0,
};

export default function promotion(state = initialState, action) {
  switch (action.type) {
    // GET PROMOTION DETAIL
    case GET_PROMOTION_DETAIL:
      return {
        ...state,
        isLoadingGetPromotionDetail: true,
      };

    case GET_PROMOTION_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetPromotionDetail: false,
        promotionDetail: action.payload,
      };

    case GET_PROMOTION_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetPromotionDetail: false,
      };

    // GET PROMOTION LIST
    case GET_PROMOTION_LIST:
      return {
        ...state,
        isLoadingGetPromotionList: true,
      };

    case GET_PROMOTION_LIST_SUCCESS:
      return {
        ...state,
        isLoadingGetPromotionList: false,
        promotionList: [...action.payload.discounts, ...action.payload.promotions],
        promotionTotal: action.payload.totalDiscounts,
      };

    case GET_PROMOTION_LIST_FAILED:
      return {
        ...state,
        isLoadingGetPromotionList: false,
      };

    // CREATE BASIC PROMOTION
    case CREATE_PROMOTION:
      return {
        ...state,
        isLoadingCreatePromotion: true,
      };

    case CREATE_PROMOTION_SUCCESS:
      return {
        ...state,
        isLoadingCreatePromotion: false,
      };

    case CREATE_PROMOTION_FAILED:
      return {
        ...state,
        isLoadingCreatePromotion: false,
      };

    // EDIT BASIC PROMOTION
    case EDIT_PROMOTION:
      return {
        ...state,
        isLoadingCreatePromotion: true,
      };

    case EDIT_PROMOTION_SUCCESS:
      return {
        ...state,
        isLoadingCreatePromotion: false,
      };

    case EDIT_PROMOTION_FAILED:
      return {
        ...state,
        isLoadingCreatePromotion: false,
      };

    // DELETE BASIC PROMOTION
    case DELETE_PROMOTION:
      return {
        ...state,
        isLoadingDeletePromotion: true,
      };

    case DELETE_PROMOTION_SUCCESS:
      return {
        ...state,
        isLoadingDeletePromotion: false,
      };

    case DELETE_PROMOTION_FAILED:
      return {
        ...state,
        isLoadingDeletePromotion: false,
      };

    // CLEAR PROMOTION DETAIL
    case CLEAR_PROMOTION_DETAIL:
      return {
        ...state,
        promotionDetail: {},
      };

    // CREATE PLACE PROMOTION
    case CREATE_PLACE_PROMOTION:
      return {
        ...state,
        isLoadingCreatePlacePromotion: true,
      };

    case CREATE_PLACE_PROMOTION_SUCCESS:
      return {
        ...state,
        isLoadingCreatePlacePromotion: false,
      };

    case CREATE_PLACE_PROMOTION_FAILED:
      return {
        ...state,
        isLoadingCreatePlacePromotion: false,
      };

    // GET PLACE PROMOTION DETAIL
    case GET_PLACE_PROMOTION_DETAIL:
      return {
        ...state,
        isLoadingGetPlacePromotionDetail: true,
      };

    case GET_PLACE_PROMOTION_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetPlacePromotionDetail: false,
        placePromotionDetail: action.payload,
      };

    case GET_PLACE_PROMOTION_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetPlacePromotionDetail: false,
      };

    // CLEAR PLACE PROMOTION DETAIL
    case CLEAR_PLACE_PROMOTION_DETAIL:
      return {
        ...state,
        placePromotionDetail: {},
      };

    // DELETE PLACE PROMOTION
    case DELETE_PLACE_PROMOTION:
      return {
        ...state,
        isLoadingDeletePlacePromotion: true,
      };

    case DELETE_PLACE_PROMOTION_SUCCESS:
      return {
        ...state,
        isLoadingDeletePlacePromotion: false,
      };

    case DELETE_PLACE_PROMOTION_FAILED:
      return {
        ...state,
        isLoadingDeletePlacePromotion: false,
      };

    // GET PLACE PROMOTION LIST
    case GET_PLACE_PROMOTION_LIST:
      return {
        ...state,
        isLoadingGetPlacePromotionList: true,
      };

    case GET_PLACE_PROMOTION_LIST_SUCCESS:
      return {
        ...state,
        isLoadingGetPlacePromotionList: false,
        placePromotionList: action.payload.data || action.payload || [],
      };

    case GET_PLACE_PROMOTION_LIST_FAILED:
      return {
        ...state,
        isLoadingGetPlacePromotionList: false,
      };

    case DELETE_PROMOTION_DISCOUNT:
      return {
        ...state,
        isLoadingDeletePromotionDiscount: true,
      };

    case DELETE_PROMOTION_DISCOUNT_SUCCESS:
      return {
        ...state,
        isLoadingDeletePromotionDiscount: false,
      };

    case DELETE_PROMOTION_DISCOUNT_FAILED:
      return {
        ...state,
        isLoadingDeletePromotionDiscount: false,
      };

    case GET_USABLE_MARKETING_PROMOTION_LIST:
      return {
        ...state,
        isLoadingGetUsableMarketingPromotionList: true,
      };

    case GET_USABLE_MARKETING_PROMOTION_LIST_SUCCESS:
      return {
        ...state,
        isLoadingGetUsableMarketingPromotionList: false,
        usableMarketingPromotionList: action.payload.data,
      };

    case GET_USABLE_MARKETING_PROMOTION_LIST_FAILED:
      return {
        ...state,
        isLoadingGetUsableMarketingPromotionList: false,
      };

    case GET_USABLE_MARKETING_PROMOTION_DETAIL:
      return {
        ...state,
        isLoadingGetUsableMarketingPromotionDetail: true,
      };

    case GET_USABLE_MARKETING_PROMOTION_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetUsableMarketingPromotionDetail: false,
        usableMarketingPromotionDetail: action.payload,
      };

    case GET_USABLE_MARKETING_PROMOTION_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetUsableMarketingPromotionDetail: false,
      };

    case CLEAR_USABLE_MARKETING_PROMOTION_DETAIL:
      return {
        ...state,
        usableMarketingPromotionDetail: {},
      };

    default:
      return state;
  }
}
